module.exports = __webpack_public_path__ + "static/intro-bg-af755bb0aeed22b2f70a71bab915d8b4.jpg";